// @flow
import dp3_2l1q1 from './l1q1';
import dp3_2l1q2 from './l1q2';
import dp3_2l1q3 from './l1q3';
import dp3_2l1q4 from './l1q4';
import dp3_2l1q5 from './l1q5';
import dp3_2l3q1 from './l3q1';
import dp3_2l3q2 from './l3q2';
import dp3_2l3q3 from './l3q3';
import dp3_2l3q4 from './l3q4';
import dp3_2l3q5 from './l3q5';
import dp3_2l3q6 from './l3q6';
import dp3_2l5q1 from './l5q1';
import dp3_2l5q2 from './l5q2';
import dp3_2l5q3 from './l5q3';
import dp3_2l5q4 from './l5q4';
import dp3_2l5q5 from './l5q5';
import dp3_2l5q6 from './l5q6';
import dp3_2l7q1 from './l7q1';
import dp3_2l7q2 from './l7q2';
import dp3_2l7q3 from './l7q3';
import dp3_2l7q4 from './l7q4';
import dp3_2l7q5 from './l7q5';
import dp3_2l7q6 from './l7q6';
import dp3_2l7q7 from './l7q7';
import dp3_2l7q8 from './l7q8';

const questions = {
    dp3_2l1q1,
    dp3_2l1q2,
    dp3_2l1q3,
    dp3_2l1q4,
    dp3_2l1q5,
    dp3_2l3q1,
    dp3_2l3q2,
    dp3_2l3q3,
    dp3_2l3q4,
    dp3_2l3q5,
    dp3_2l3q6,
    dp3_2l5q1,
    dp3_2l5q2,
    dp3_2l5q3,
    dp3_2l5q4,
    dp3_2l5q5,
    dp3_2l5q6,
    dp3_2l7q1,
    dp3_2l7q2,
    dp3_2l7q3,
    dp3_2l7q4,
    dp3_2l7q5,
    dp3_2l7q6,
    dp3_2l7q7,
    dp3_2l7q8
}
export default questions;



// WEBPACK FOOTER //
// ./src/constants/dp/questions/cat3.2/index.js